export default __webpack_public_path__ + "static/media/profile.5fc9e63a.svg";